var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"w-100",attrs:{"variant":_vm.color(_vm.params.value)}},[_vm._v(" "+_vm._s(_vm.opinionName(_vm.params.value))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }